import createHeaders from "@utils/createHeaders";

export const headers = createHeaders ([
  { text: 'No', value: 'number_index', width: '10' },
  { text: '', value: 'expand_action', width: '10' },
  { text: 'Trace ID', value: 'trace_id' },
  { text: 'Type', value: 'process_name'},
  { text: 'Bill Number', value: 'billNumber' },
  { text: 'Request Time', value: 'inserted'},
  { text: 'Brief Activity', value: 'custom_status', width: '400', align: 'center' },
]);

export const search = {
  trace_id: '',
  bill_number: '',
  merchant_id: '',
  rrn: '',
  process_name: '',
  status: '',
  request_date: [],  
};